import * as tslib_1 from "tslib";
import { DisplayObjectContainer } from "./display/DisplayObjectContainer";
var Scene = (function (_super) {
    tslib_1.__extends(Scene, _super);
    function Scene() {
        var _this = _super.call(this) || this;
        _this._objects = new Object();
        _this._views = new Array();
        _this._iCollectionMark = 0;
        _this.mouseEnabled = false;
        _this._iIsRoot = true;
        _this._iIsPartition = true;
        _this._pScene = _this;
        _this._pPartition = _this;
        return _this;
    }
    Object.defineProperty(Scene.prototype, "assetType", {
        /**
         *
         */
        get: function () {
            return Scene.assetType;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @internal
     */
    Scene.prototype._iRegisterObject = function (displayObject) {
        this._objects[displayObject.id] = displayObject;
        var len = this._views.length;
        for (var i = 0; i < len; i++)
            this._views[i].registerObject(displayObject);
    };
    /**
     * @internal
     */
    Scene.prototype._iUnregisterObject = function (displayObject) {
        delete this._objects[displayObject.id];
        var len = this._views.length;
        for (var i = 0; i < len; i++)
            this._views[i].unRegisterObject(displayObject);
    };
    /**
     * @internal
     */
    Scene.prototype._iRegisterView = function (view) {
        this._views.push(view);
        for (var key in this._objects)
            view.registerObject(this._objects[key]);
    };
    /**
     * @internal
     */
    Scene.prototype._iUnregisterView = function (view) {
        this._views.splice(this._views.indexOf(view), 1);
        for (var key in this._objects)
            view.unRegisterObject(this._objects[key]);
    };
    return Scene;
}(DisplayObjectContainer));
export { Scene };
Scene.assetType = "[asset Scene]";



// WEBPACK FOOTER //
// ../dist/lib/Scene.js